import { render, staticRenderFns } from "./tambahPengguna.vue?vue&type=template&id=6addfc02&"
import script from "./tambahPengguna.vue?vue&type=script&lang=js&"
export * from "./tambahPengguna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports